import { PromotionRepository } from '../../domain/repositories/promotion.repository';
import { PromotionEntity } from '../../domain/entities/promotion.entity';

export class GetPromotionsUseCase {
  constructor(private readonly promotionRepository: PromotionRepository) {}

  async execute(options?: {
    activeOnly?: boolean;
    currentlyValid?: boolean;
    search?: string;
    productId?: string;
  }): Promise<PromotionEntity[]> {
    return this.promotionRepository.getPromotions(options);
  }
}
